var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaySecond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1679_204872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z",
    fill: "url(#paint0_linear_1679_204872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 100H0C0 155.229 44.7715 200 100 200C155.229 200 200 155.229 200 100Z",
    fill: "#55217E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6559 156.641C71.7445 156.641 70.8305 156.429 69.9891 155.998C68.0297 154.996 66.7969 152.982 66.7969 150.781V49.2188C66.7969 47.0184 68.0297 45.0035 69.9887 44.002C71.9477 43.0004 74.3027 43.1805 76.0867 44.4688L146.399 95.25C147.925 96.3516 148.828 98.1188 148.828 100C148.828 101.881 147.925 103.648 146.399 104.75L76.0867 155.531C75.0691 156.266 73.8656 156.641 72.6559 156.641Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7969 100V150.781C66.7969 152.982 68.0297 154.996 69.9887 155.998C70.8301 156.429 71.7445 156.641 72.6555 156.641C73.8652 156.641 75.0691 156.266 76.0867 155.531L146.399 104.75C147.924 103.648 148.828 101.881 148.828 100H66.7969Z",
    fill: "#E2DFF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1679_204872",
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55217E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1679_204872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySecond);
export default __webpack_public_path__ + "static/media/playSecond.a027bc87.svg";
export { ForwardRef as ReactComponent };